export default class ReactError extends Error {
  
  static type = "ReactError";
  
  constructor(error, info) {
    super(`Exception thrown in react tree: ${error.toString()}`);
    this.originalError = error;
    this.details = info;
    this.type = ReactError.type;
  }
  
}



// WEBPACK FOOTER //
// ./src/lib/ReactError.js